import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { PaperBG } from "../kits/DesignKit";
import ContactIntroSection from "./ContactIntroSection";
import ContactInfoGrid from "./ContactInfoGrid";
import ContactForm from "./ContactForm";
import { Helmet } from "react-helmet";
import { contactSchema } from "./utils/ContactSchema";
import RoughBorder from "../kits/LayoutKit/RoughBorder";
import { PaperZenBG } from "../kits/DesignKit";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.state]);

  const handleSoftScrollToMap = () => {
    const section = document.getElementById("map-section");
    if (section) {
      const topPosition = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: topPosition - 50,
        behavior: "smooth",
      });
    }
  };

  // Ref für den Karten-Container
  const mapRef = useRef();

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(contactSchema)}
        </script>
      </Helmet>
      <PaperBG className="pb-12">
        <div className="space-y-16 px-4 md:px-12">
          {/* Begrüßung */}
          <ContactIntroSection />

          {/* Kontaktinformationen */}
          <div className="max-w-3xl mx-auto">
            <ContactInfoGrid onShowMapClick={handleSoftScrollToMap} />
          </div>

          {/* Kontaktformular */}
          <div className="max-w-3xl mx-auto">
            <ContactForm />
          </div>

          {/* Karte mit RoughBorder */}
          <div
            id="map-section"
            ref={mapRef}
            className="relative max-w-3xl mx-auto group"
          >
            <div className="rounded-lg overflow-hidden shadow-sm filter grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out">
            <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2369.5234!2d10.006891!3d53.553404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b18f1b8e8e8e8f%3A0x0!2sFerdinandstra%C3%9Fe%2015%2C%2020095%20Hamburg!5e0!3m2!1sde!2sde!4v1730000000000!5m2!1sde!2sde"
    allowFullScreen=""
    loading="lazy"
    className="w-full h-96 border-0"
    title="Standortkarte - Ferdinandstraße 15, Hamburg"
  ></iframe>
            </div>
            {/* RoughBorder GANZ AUSSEN um die Karte */}
            <RoughBorder
              parentRef={mapRef}
              radius={13}
              padding={2}
              color="#AC8E66" 
              strokeWidth={0.3}
              roughness={1}
              bowing={2}
            />
          </div>
        </div>
      </PaperBG>
    </>
  );
};

export default Contact;
